import { useMemo } from "react";
import { CSSProperties } from "@mui/styles";
import { EventReportsEntity } from "entities/EventReports/EventReportsEntity";
import { IOption } from "../Dropdown";
import { SegmentFieldVariant, SegmentSelect } from "./SegmentSelect";

interface IOperatorFieldProps {
    machineCenterId: number;
    clusterId?: number | null;
    value?: number;
    inlineStyle?: CSSProperties;
    variant?: SegmentFieldVariant;
    placeholder?: string;
    onChange: (userId: number) => void;
}

/** Controlled operator selector reused by the inline table edit and the split modal. */
export const OperatorField = ({
    machineCenterId,
    clusterId,
    value,
    inlineStyle,
    variant = "inline",
    placeholder,
    onChange,
}: IOperatorFieldProps) => {
    const { loading, operators } = EventReportsEntity.GetOperatorsForEventEdition(machineCenterId, clusterId);

    const options: IOption[] = useMemo(
        () => operators.map((operator) => ({ name: `${operator.user.first_name} ${operator.user.last_name}`, id: operator.user.user_id })),
        [operators],
    );

    return (
        <SegmentSelect
            variant={variant}
            value={value}
            options={options}
            onChange={onChange}
            loading={loading}
            placeholder={placeholder}
            inlineStyle={inlineStyle}
        />
    );
};
